var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"toggle-button",class:( _obj = {on: !!_vm.value}, _obj[(_vm.onColor + " bg")] = !!_vm.value, _obj[(_vm.offColor + " bg")] = !_vm.value, _obj.disabled = _vm.disabled, _obj ),attrs:{"type":"button","disabled":_vm.disabled},on:{"click":_vm.toggle}},[_c('md-icon',{class:(_vm.iconColor + " color")},[_vm._v(_vm._s(_vm.icon))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }